import { auth } from "@/lib/auth/client";
import { LoaderCircle } from "lucide-react";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";

export function DashboardGuard() {
  const { data: session, isPending } = auth.useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isPending && !session) {
      navigate("/login", { replace: true });
    }
  }, [isPending, session, navigate]);

  if (isPending) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <div className="flex items-center gap-2 text-muted-foreground">
          <LoaderCircle className="size-5 animate-spin" />
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!session) {
    return null;
  }

  return <Outlet />;
}
